import { Link } from '@/components/ui/link';
import { Tooltip } from '@/components/ui/tooltip';
import { AlertStatus } from '@/entities/alert-status';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { cls } from '@/utils/cls';

import type { Unit } from '../entities/unit';

export type UnitViewProps = {
  unit: Unit;
};

const colorFromAlertStatus: Record<AlertStatus, string> = {
  [AlertStatus.OK]: 'bg-emerald-500',
  [AlertStatus.INFO]: 'bg-[#86DFC2]',
  [AlertStatus.WARNING]: 'bg-yellow-500',
  [AlertStatus.TRIPPED]: 'bg-yellow-500',
  [AlertStatus.CRITICAL]: 'bg-red-500',
};

export function UnitView({ unit }: UnitViewProps) {
  const featureFlag = useFeatureFlag();

  if (!featureFlag('details')) {
    return (
      <Tooltip
        content={
          unit.alert.suggestedAction
            ? `${unit.id}: ${unit.alert.suggestedAction}`
            : unit.id
        }
      >
        <div
          className={cls('size-5', colorFromAlertStatus[unit.alert.status])}
        />
      </Tooltip>
    );
  }

  return (
    <Link
      className="size-5"
      to={{
        pathname: '/details',
        search: new URLSearchParams({
          top_id: unit.topId,
          unit_id: unit.id,
        }).toString(),
      }}
    >
      <Tooltip
        content={
          unit.alert.suggestedAction
            ? `${unit.id}: ${unit.alert.suggestedAction}`
            : unit.id
        }
      >
        <div
          className={cls('size-5', colorFromAlertStatus[unit.alert.status])}
        />
      </Tooltip>
    </Link>
  );
}
